import React from "react";
import AssetCategoryPage from "./AssetCategoryPage";

const RoomAssets = () => {
  return <AssetCategoryPage category="Room" title="Room" />;
};

export default RoomAssets;
